export default __webpack_public_path__ + "static/media/coin.49ffe781.svg";